<template>
	<form>
		<PersonNameForm ref="PersonNameForm" v-model="person" @input="personChanged" :disabled="disabled" :show-company="false" />

		<div class="flex flex-wrap">
			<BaseInput
				ref="BaseInput-street"
				:required="false"
				class="md:w-1/2 pl-0 md:pr-2"
				:label="$t('street')"
				:placeholder="$t('street')"
				type="text"
				@input="personChanged"
				v-model="person.street"
				:disabled="disabled"
			/>

			<BaseInput
				ref="BaseInput-housenumber"
				:required="false"
				class="md:w-1/2 pl-0 md:pl-2"
				:label="$t('number')"
				:placeholder="$t('number')"
				type="tel"
				@input="personChanged"
				v-model="person.houseNumber"
				:disabled="disabled"
			/>
		</div>

		<CityInput ref="BaseInput-city" v-model="person.city" @input="personChanged" :disabled="disabled" :required="isCityStarted" />

		<div class="flex flex-wrap">
			<BaseInput
				ref="BaseInput-telephone"
				:required="true"
				class="md:w-1/2 pr-0 md:pr-2"
				:label="$t('phone')"
				:placeholder="$t('phone')"
				type="tel"
				validationtype="phone"
				@input="personChanged"
				v-model="person.cellNumber"
				:disabled="disabled"
			/>

			<BaseInput
				ref="BaseInput-email"
				validationtype="email"
				:required="false"
				class="md:w-1/2 pl-0 md:pl-2"
				:label="$t('e_mail')"
				:placeholder="$t('e_mail')"
				type="email"
				@input="personChanged"
				:error-message="$t('e_mail_not_valid')"
				v-model="person.email"
				:disabled="disabled"
			/>
		</div>
	</form>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import PersonNameForm from '@/components/forms/PersonNameForm';
import CityInput from '@/components/forms/CityInput';
import Validate from '@/mixins/Validate';

export default {
	name: 'DamageAssessorCaseCustomerForm',

	components: {
		BaseInput,
		PersonNameForm,
		CityInput,
	},

	mixins: [Validate],

	props: {
		value: {
			type: Object,
			default: () => ({}),
		},

		disabled: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			person: this.createEmptyPerson(),
		};
	},
	computed: {
		isCityStarted() {
			return !!(this.person?.city?.zipCode?.toString().trim() || this.person?.city?.name?.toString().trim());
		},
	},
	mounted() {
		this.setStartValue(this.value);
	},

	methods: {
		createEmptyPerson() {
			return {
				title: null,
				gender: null,
				firstName: null,
				lastName: null,
				street: null,
				houseNumber: null,
				poBox: null,
				phoneNumber: null,
				cellNumber: null,
				email: null,
				organisation: null,

				city: {
					id: null,
					zipCode: null,
					name: null,
				},
			};
		},
		setStartValue(value) {
			if (!value) {
				this.person = this.createEmptyPerson();
				return;
			}
			this.person = {
				...this.createEmptyPerson(),

				title: value.title ?? null,
				gender: value.gender ?? null,
				firstName: value.firstName ?? null,
				lastName: value.lastName ?? null,
				street: value.street ?? null,
				houseNumber: value.houseNumber ?? null,
				poBox: value.poBox ?? null,
				phoneNumber: value.phoneNumber ?? null,
				cellNumber: value.cellNumber ?? null,
				email: value.email ?? null,
				organisation: value.organisation ?? null,

				city: {
					id: value.city?.id ?? null,
					zipCode: value.city?.zipCode ?? null,
					name: value.city?.name ?? null,
				},
			};
		},
		personChanged() {
			this.$emit('input', this.person);

			this.$emit('updateValue', this.person);
		},
		clear() {
			this.person = this.createEmptyPerson();

			if (this.$refs.PersonNameForm) {
				this.$refs.PersonNameForm.clear();
			}

			this.personChanged();
		},
	},

	watch: {
		value(newValue) {
			if (newValue === this.person) {
				return;
			}

			this.setStartValue(newValue);
		},
	},
};
</script>

<style scoped></style>
